module.exports = "<div class=\"range-input\">\n\t<output for=\"::vm.item.id\" ng-class=\"'pos'+vm.item.value\">{{vm.interestLabel}}</output>\n  <input type=\"range\" name=\"::vm.item.id\" min=\"0\" max=\"10\" ng-model=\"vm.item.value\" />\n  <label class=\"interest-label\" ng-bind=\"::vm.item.name\"></label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/rangeInput/rangeInput.html
// module id = 24
// module chunks = 0 1